import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "substatus-bar",
    "data-testid": "substatus-bar"
};
const _hoisted_2 = { class: "substatus-bar__label" };
const _hoisted_3 = {
    key: 0,
    class: "substatus-bar__error"
};
import { computed, ref, watch } from "vue";
import SubstatusChips from "@/components/dashboard/SubstatusChips.vue";
import { substatusChipDefs } from "@/models/substatusTags";
import { patientService } from "@/services/patientService";
import { useRequirementsStore } from "@/stores/requirementsStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubstatusBar',
    props: {
        entityType: {},
        entityId: {}
    },
    setup(__props) {
        const props = __props;
        const requirementsStore = useRequirementsStore();
        const definitions = computed(() => {
            const config = requirementsStore.clientConfig;
            const section = props.entityType === "submission" ? config?.priorAuth : config?.intake;
            return section?.substatusTags || [];
        });
        const tags = ref([]);
        const loadError = ref(false);
        const chipCount = computed(() => substatusChipDefs(tags.value, definitions.value).length);
        let requestSeq = 0;
        async function load() {
            const seq = ++requestSeq;
            tags.value = [];
            loadError.value = false;
            if (!props.entityId || !definitions.value.length)
                return;
            try {
                const data = await patientService.getCaseSubstatusTags(props.entityType, props.entityId);
                if (seq === requestSeq)
                    tags.value = data?.substatusTags || [];
            }
            catch (ex) {
                // 404: a case another tenant owns (Lamar ops acting as the admin company) — no chips, as on the grids.
                if (seq === requestSeq)
                    loadError.value = ex?.response?.status !== 404;
            }
        }
        watch([() => props.entityType, () => props.entityId, () => JSON.stringify(definitions.value.map((d) => d.key))], load, {
            immediate: true,
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (definitions.value.length && (chipCount.value || loadError.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createTextVNode("mdi-list-status", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode(" Substatus ", -1))
                    ]),
                    (loadError.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Couldn't load substatus"))
                        : (_openBlock(), _createBlock(SubstatusChips, {
                            key: 1,
                            tags: tags.value,
                            definitions: definitions.value,
                            size: "md"
                        }, null, 8, ["tags", "definitions"]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
